import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

interface Props {
    id: string;
    name?: string;
    isActive?: boolean;
}

const usePatchSlackChannels = () => {
    const { t } = useTranslation('integrations');
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);

    const patchUserSlackChannels = (prop: Props[]): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.patchUsersSlackChannels({
                body: prop,
                onSuccess: () => {
                    toastHandler.push('success', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsDescription'));
                    resolve();
                },
                onError: error => {
                    if (error.includes('fails to match the required pattern')) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorSpecialCharacters'));
                    } else if (error.includes('already exists')) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorNameExists'));
                    } else if (error.includes('Channel name is already taken')) {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsErrorReservedWord'));
                    } else {
                        toastHandler.push('error', t('slack.patchSlackChannelsTitle'), t('slack.patchSlackChannelsError'));
                    }
                    reject(new Error('Failed to patch Slack channels'));
                },
            });
            exec();
        });
    };

    return { patchUserSlackChannels };
};

export default usePatchSlackChannels;
